/* Moomo R2 · Email popup: timing, steps, validation, focus handling. Submission is Shopify's own customer form. */
(() => {
  const KEY = 'mmPopup';
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } };
  const write = (v) => { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* private mode: show again next visit */ } };
  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  const init = (root) => {
    if (root.dataset.mmReady) return;
    root.dataset.mmReady = '1';
    const card = root.querySelector('.mm-pop__card');
    const form = root.closest('form');
    const steps = [...root.querySelectorAll('[data-step]')];
    const email = root.querySelector('[data-mm-pop-email]');
    const error = root.querySelector('[data-mm-pop-error]');
    const tags = root.querySelector('[data-mm-pop-tags]');
    const days = Number(root.dataset.days) || 14;
    let lastFocus = null;

    const loadFonts = () => {
      if (document.querySelector('link[data-mm-pop-fonts]')) return;
      const l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = root.dataset.fonts; l.dataset.mmPopFonts = '';
      document.head.appendChild(l);
    };
    const show = (name) => {
      steps.forEach((s) => { s.hidden = s.dataset.step !== name; });
      root.dataset.step = name;
      const first = root.querySelector(`[data-step="${name}"] input, [data-step="${name}"] button`);
      (name === 'email' ? email : first || card).focus({ preventScroll: true });
    };
    const open = (step) => {
      loadFonts();
      lastFocus = document.activeElement;
      root.hidden = false;
      document.documentElement.classList.add('mm-pop-open');
      requestAnimationFrame(() => root.classList.add('is-open'));
      show(step || 'mood');
    };
    const close = (remember = true) => {
      root.classList.remove('is-open');
      root.hidden = true;
      document.documentElement.classList.remove('mm-pop-open');
      const st = read();
      if (remember && !(st && st.done)) write({ until: Date.now() + days * 864e5 });
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    };

    root.querySelectorAll('[data-mm-pop-close]').forEach((b) => b.addEventListener('click', () => close()));
    root.querySelectorAll('[data-mm-pop-mood]').forEach((b) => b.addEventListener('click', () => {
      tags.value = `newsletter,popup,mood-${b.dataset.mmPopMood}`;
      show('email');
    }));
    const setError = (on) => {
      error.hidden = !on;
      root.classList.toggle('has-error', on);
      email.setAttribute('aria-invalid', String(on));
    };
    email.addEventListener('input', () => { if (!error.hidden && EMAIL.test(email.value.trim())) setError(false); });
    form.addEventListener('submit', (e) => {
      if (!EMAIL.test(email.value.trim())) { e.preventDefault(); setError(true); email.focus(); return; }
      write({ pending: true, until: Date.now() + days * 864e5 });
    });

    root.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      const f = [...card.querySelectorAll('button, a[href], input:not([type="hidden"])')].filter((el) => el.offsetParent !== null);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });

    // after Shopify's form round-trip, reopen on the result
    const start = root.dataset.start;
    // Shopify returns to #MoomoPopupForm (end of <body>): stay at the top of the page instead
    if (location.hash === '#MoomoPopupForm') {
      history.replaceState(null, '', location.pathname + location.search);
      window.scrollTo(0, 0);
    }
    if (start === 'success') { write({ done: true }); open('success'); return; }
    if (start === 'error') { open('email'); setError(true); return; }

    // theme editor: open while the section is selected
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:select', (e) => { if (e.target.contains(root)) open('mood'); });
      document.addEventListener('shopify:section:deselect', (e) => { if (e.target.contains(root)) close(false); });
      return;
    }

    const st = read();
    if (st && (st.done || (st.until && st.until > Date.now()))) return;
    // never stack on top of Shopify's cookie banner: wait until the visitor has dealt with it
    const bannerUp = () => {
      const b = document.getElementById('shopify-pc__banner');
      if (!b) return false;
      const cs = getComputedStyle(b);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && Number(cs.opacity) > 0 && b.getBoundingClientRect().height > 0;
    };
    const tryOpen = () => {
      if (document.documentElement.classList.contains('mm-pop-open')) return;
      if (bannerUp()) { setTimeout(tryOpen, 1500); return; }
      open('mood');
    };
    setTimeout(tryOpen, (Number(root.dataset.delay) || 8) * 1000);
  };

  const boot = () => document.querySelectorAll('[data-mm-pop]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
